<template>
  <BaseTable
      :title="$t('task_template')"
      :subtractHeight="subtractHeight"
      :height="height"
      dto-model="TaskTemplateListQueryDTO"
      dto-save-list-model="TaskTemplateSaveListCommandDTO"
      store-name="TaskTemplateTable"
      new-item-component="TaskTemplateItem"
      new-item-pass="/Product/TaskTemplate/TaskTemplateItem"
      :lang-dictionary="function(text) {return $t(text)}"
      fixed-header
      :modal-dialog="modalDialog"
      :single-select="singleSelect"
      :actionSelected="actionSelected"
      @choice="$emit('choice', $event)"
  >
    <template v-slot:item.name="{ item }">
      <router-link :to="{name:'TaskTemplateItem', params: { itemUid: item.uid}}">
        <span v-if="item.name">{{ item.name }}</span>
        <span v-else>****</span>
      </router-link>
    </template>
    <template v-slot:item.group="{ item }">
      {{ $t('groups.' + item.group) }}
    </template>
    <template v-slot:item.task_types="{ item }">
      <v-chip small v-for="task in item.task_types" :key="task.name" :color="task.color">
        {{ task.name }}
      </v-chip>
      <span v-if="item.task_types.length === 0"> </span>
    </template>
  </BaseTable>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";

export default {
  name: 'TaskTemplateTable',
  props: {
    subtractHeight: {type: [Number], default: 140},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false},
    singleSelect: {type: [Boolean], default: true},
    actionSelected: {default: false},
  },

  components: {
    BaseTable,
  },

  computed: {},

  methods: {},

  async mounted() {
    // console.log('mounted')
  },

  data() {
    return {}
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n src=".\locales.json">
</i18n>
